import Router from './router'
import GlobalStyle from './presentation/styles/global-styles'
import { BrowserRouter } from 'react-router-dom'
import { type ReactElement } from 'react'
import { ModalProvider } from './presentation/contexts/modal-context/modal-context'

export default function App (): ReactElement {
  return <BrowserRouter>
    <ModalProvider>
      <Router />
      <GlobalStyle />
    </ModalProvider>
  </BrowserRouter>
}
